import type {ReactNode} from "react";

import {Checkbox} from "@khanacademy/wonder-blocks-form";

interface SignUpLegalBlurbProps {
    checked: boolean;
    setChecked: (value: boolean) => void;
    legalBlurb: ReactNode;
}

export const SignUpLegalBlurb = ({
    setChecked,
    legalBlurb,
    checked,
}: SignUpLegalBlurbProps) => {
    return (
        <Checkbox
            testId="tos-checkbox"
            onChange={() => setChecked(!checked)}
            checked={checked}
            label={legalBlurb}
        />
    );
};
